import _ from 'lodash';
import React, { lazy, useEffect, useState } from 'react';
import { GridApi, } from "ag-grid-community";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
import * as selector from '../../selectors/selectors';
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import PageHeaderComponent from "../shared/page-header.component";
import SecureFile from "./secure-file.component";
import UploadSecureFile from "./upload-secure-file.component";
import { LoadFaceAuthenticationFiles, LoadSecureFiles } from '../../actions';
import SendInviteComponent from "./send-invite-component";
import { UserService } from "../../services/UserService";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import ButtonComponent from '../shared/button/button.component';
import FilterComponent from "../shared/filters/filter.component";
import { SecureFileService } from "../../services/SecureFileService";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import SecureFileFaceAuthentication from "./face-authentication.component";
import { FaceAuthenticationModel, SecureFileModel, SecureFileStatusModel } from "../../models/secure-file";
import { ActionLabels, appNote, buttonLabels, DialogHeaders, pageTitles, ToasterTexts } from "../shared/constants";
import { Dialog, DialogActions, DialogContent, DialogTitle, Popover, TextField, Tooltip } from "@mui/material";
import { CancelIcon, MultiSelectDeleteIcon, NewInfoCircleIcon, UploadSecureFileIcon, UploadSuccessIcon, SendInviteFaceIcon } from "../../icon";
import { setHeaderTitle, setRefreshHandler } from '../../helpers/header.helper';
import { PlanMetrics } from '../../models/plan-metrics.model'
import ConfirmDialog from "../shared/confirm-dialog.component";

interface SecureFileProps {
    IsSecureFileLink: boolean;
    IsSecureFileFaceAuthentication: boolean;
}

const SecureFiles: React.FC<SecureFileProps> = (props: SecureFileProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    let id = { "user_id": UserService.getCurrentUserId() }
    const SecureFiles: SecureFileModel[] = useSelector(selector.secureFiles)
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)

    const [gridApi, setGridApi] = useState<GridApi>(null)
    const [showGetLinkDialog, setShowGetLinkDialog] = useState<boolean>(false)
    const [getUrlLink, setGetUrlLink] = useState<string>("")
    const [faceUrlLink, setFaceUrlLink] = useState<string>("")
    const [showUploadSecureFile, setUploadSecureFile] = useState<boolean>(false)
    const [showSendInvite, setSendInvite] = useState<boolean>(false)
    const [copyStatus, setCopyStatus] = useState({ urlCopied: false, faceUrlCopied: false })
    const [anchorEl, setAnchorEl] = useState<Element | null>();
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [columnApi, setcolumnApi] = useState<any>(null)
    const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false)
    const [checkedContacts, setCheckedContacts] = useState<FaceAuthenticationModel[]>([]);
    const [checkedFiles, setCheckedFiles] = useState<SecureFileModel[]>([]);
    const [showContactDeleteConfirmDialog, setShowContactDeleteConfirmDialog] = useState<boolean>(false);
    const [showFilesDeleteConfirmDialog, setShowFilesDeleteConfirmDialog] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    // const getGridTitle = () => {
    //     return SecureFiles.length === 1 ? SecureFiles.length + " " + pageTitles.Links.substring(0, pageTitles.Links.length - 1) : SecureFiles.length + " " + pageTitles.Links
    // }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setcolumnApi(params.columnApi)
    }

    useEffect(() => {
        setHeaderTitle(location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE ? pageTitles.SECURE_FILES : pageTitles.FACE_AUTHENTICATION_FILES)
        setRefreshHandler(gridRefresh);
        if (searchText !== "") {
            gridApi.setQuickFilter(searchText);
        }
        return setHeaderTitle
    }, [gridApi, columnApi])

    const gridRefresh = () => {
        LoadSecureFiles(dispatch, id)
        if (PlanMetrics?.HasAccessToFaceVault) {
            LoadFaceAuthenticationFiles(dispatch, UserService.getCurrentUserOrgId())
        }
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
        deselectAll()
    }

    useEffect(() => {
        setSearchText("")
        setCheckedContacts([])
        setCheckedFiles([])
        setShowMultiActionButtons(false)
    }, [location.pathname])

    const searchReport = (e: any) => {
        setSearchText(e.target.value);
        gridApi?.setQuickFilter(e.target.value);
    }

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const openUplaodFileDialog = () => {
        setUploadSecureFile(true)
    }

    const openSendInvite = () => {
        setSendInvite(true)
    }

    const initialFilterOptions = () => {
        const filterData: any[] = [
            {
                Id: 1,
                Title: 'Status',
                IsSelectedAll: false,
                Options: _(SecureFiles)
                    .map((row, index) => ({
                        Key: "Status",
                        Id: index + 1,
                        Label: row.Status === SecureFileStatusModel.Active ? "Active" : "Expired",
                        Value: row.Status,
                        IsSelected: false,
                    }))
                    .uniqBy('Label')
                    .value()
            },
        ]
        setFilterOptions(filterData)
    }

    const resetFilters = () => {
        setFilterOptions([])
        setSelectedFilterTypes([])
        initialFilterOptions()
    }

    const closeUploadFileDialog = (isConfim, data) => {
        if (isConfim) {
            LoadSecureFiles(dispatch, id)
            setShowGetLinkDialog(true)
            setGetUrlLink(data?.url)
            setFaceUrlLink(data?.faceUrl)
        }
        setUploadSecureFile(false)
        resetFilters()
    }

    const closeSendInvite = () => {
        setSendInvite(false)
    }

    const closeGetLinkDialog = () => {
        setShowGetLinkDialog(false)
        setCopyStatus({ urlCopied: false, faceUrlCopied: false })
        setGetUrlLink("")
    }

    const copyToClipboard = (text, isTeamsApp, fallbackCopyMethod) => {
        if (isTeamsApp) {
            fallbackCopyMethod(text);
        } else {
            navigator.clipboard.writeText(text);
        }
    }

    const copyEmailLink = () => {
        setCopyStatus({ urlCopied: true, faceUrlCopied: false });
        copyToClipboard(getUrlLink, IsTeamsApp, copyTextFallback);
    }

    const copyFaceLink = () => {
        setCopyStatus({ urlCopied: false, faceUrlCopied: true });
        copyToClipboard(faceUrlLink, IsTeamsApp, copyTextFallback);
    }

    const copyTextFallback = (text) => {
        const newElement = document.createElement("div");
        newElement.textContent = text;
        document.body.appendChild(newElement);
        const range = document.createRange();
        range.selectNode(newElement);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("copy");
        document.body.removeChild(newElement);
    }

    const onSelectionChanged = (data) => {
        if (data?.length > 0) {
            setShowMultiActionButtons(true);
            setCheckedContacts(data);
        }
        else {
            setShowMultiActionButtons(false);
            setCheckedContacts([])
        }
    }

    const onFilesSelectionChanged = (data) => {
        if (data?.length > 0) {
            setShowMultiActionButtons(true);
            setCheckedFiles(data);
        }
        else {
            setShowMultiActionButtons(false);
            setCheckedFiles([])
        }
    }

    const closeContactDeleteConfirmDialog = (isConfim) => {
        setIsLoading(true)
        let data = { phone_numbers: checkedContacts?.map(x => x?.ContactPhoneNumber) }
        if (isConfim) {
            SecureFileService.deleteInviteLinks(UserService.getCurrentUserFromLocalStorage()?.OrgId, data).then((res) => {
                setIsLoading(false)
                setShowContactDeleteConfirmDialog(false)
                setShowMultiActionButtons(false);
                setCheckedContacts([])
                setToast(ToasterTexts.DELETE_INVITE, ToasterType.SUCCESS)
            }).catch((err) => {
                setIsLoading(false)
                setShowContactDeleteConfirmDialog(false)
                setShowMultiActionButtons(false);
                setCheckedContacts([])
            })
        }
        else {
            setIsLoading(false)
            setShowContactDeleteConfirmDialog(false)
        }
    }
    const deselectAll = () => {
        if (!!gridApi && !!checkedFiles.length) {
            gridApi.deselectAll();
        }
    }
    const closeSecureFilesDeleteConfirmDailog = (isConfirm) => {
        const data = {
            "ids": checkedFiles.map(x => x.Id),
            "user_id": UserService.getCurrentUserId(),
        }
        if (isConfirm) {
            SecureFileService.SecureFilesMassDelete(data).then((res) => {
                setIsLoading(false)
                setShowFilesDeleteConfirmDialog(false)
                setShowMultiActionButtons(false);
                setCheckedFiles([])
                setToast(ToasterTexts.SECUREFILES_MASSDELETE, ToasterType.SUCCESS)
                deselectAll()
            }).catch((err) => {
                setIsLoading(false)
                setShowFilesDeleteConfirmDialog(false)
                setShowMultiActionButtons(false);
                setCheckedFiles([])
                deselectAll()
            })
        }
        else {
            setIsLoading(false)
            setShowFilesDeleteConfirmDialog(false)
            deselectAll()
        }
    }


    return (
        <>
            {
                <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                    <PageHeaderComponent
                        // GridTitle={getGridTitle()}
                        onSearch={searchReport}
                        Count={SecureFiles?.length}
                        PlaceHolder={"Find..."}
                        Actions={
                            location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE
                                ? [
                                    {
                                        OnClick: () => openUplaodFileDialog(),
                                        ButtonLabel: buttonLabels.UPLOAD,
                                        Icon: UploadSecureFileIcon,
                                        Variant: "primary-btn-small",
                                    }
                                ]
                                : [
                                    {
                                        OnClick: () => openSendInvite(),
                                        ButtonLabel: buttonLabels.SEND_INVITE,
                                        Icon: SendInviteFaceIcon,
                                        Variant: "primary-btn-small",
                                    }
                                ]
                        }
                        HandleFilter={handleClickFilter}
                        ShowFilterIcon={false}
                        IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected))?.length}
                        ShowMultiActionButtons={showMultiActionButtons}
                        MultiActionButtons={[
                            {
                                Name: ActionLabels.DELETE,
                                Variant: (location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE ? checkedFiles?.length : checkedContacts?.length) ? "primary" : "disabled",
                                ClassName: "mr-1",
                                Icon: MultiSelectDeleteIcon,
                                OnClick: () => { location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE ? setShowFilesDeleteConfirmDialog(true) : setShowContactDeleteConfirmDialog(true) },
                                Hide: !(location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE ? checkedFiles?.length : checkedContacts?.length)
                            },
                        ]}
                    />

                    {PlanMetrics?.HasAccessToFaceVault &&
                        <div className="d-flex justify-between w-p-100 px-2">
                            <div>
                                <div className='d-flex'>
                                    <Link className={`${location.pathname === AppRoutes.SECURE_FILE ? 'ml-1 w-14 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'ml-1 w-14 t-align-center py-1 c-pointer color-conv-section-inactive h4-semibold'}`} to={AppRoutes.SECURE_FILE}>
                                        {"Secure File"}
                                        <Tooltip title={appNote.SECURE_FILE_LINK} >
                                            <span style={{ marginLeft: "0.3rem", position: 'relative', top: "2px" }}>
                                                <NewInfoCircleIcon />
                                            </span>
                                        </Tooltip>
                                    </Link>
                                    <Link className={`${location.pathname === AppRoutes.SECURE_FILE_FACE_AUTHENTICATION ? 'w-18 t-align-center py-1 c-pointer color-conv-hist-menu  h4-semibold' : 'w-20 t-align-center py-1 c-pointer color-conv-section-inactive h4-semibold'}`} to={AppRoutes.SECURE_FILE_FACE_AUTHENTICATION}>
                                        {"Face Vault"}
                                        <Tooltip title={appNote.SECURE_FILE_FACE_AUTHENTICATION} >
                                            <span style={{ marginLeft: "0.3rem", position: 'relative', top: "2px" }}>
                                                <NewInfoCircleIcon />
                                            </span>
                                        </Tooltip>
                                    </Link>
                                </div>
                                <div className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light ${location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE ? "ml-1 w-14" : "ml-16 w-16"}`} />
                            </div>
                        </div>
                    }
                    {
                        <Dialog
                            maxWidth="sm"
                            fullWidth={true}
                            BackdropProps={{ style: { backgroundColor: "transparent" } }}
                            open={showGetLinkDialog}
                            onClose={() => closeGetLinkDialog()}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            classes={{ paper: "br-2 w-p-33 dialogue-shadow" }}
                            disableEscapeKeyDown
                        >
                            <DialogTitle>
                                <div className="d-flex align-center justify-between">
                                    <div className="flex-grow-1 d-flex justify-center align-center">
                                        <span className="h3-semibold mt-1 color-secure-file-dialog-title">{DialogHeaders.UPLOAD_SUCCESS}</span>
                                    </div>
                                    <CancelIcon onClick={() => closeGetLinkDialog()} className="c-pointer mr-1 mt-1" />
                                </div>
                                <div className="d-flex justify-center align-center mt-2 mr-1"><UploadSuccessIcon /></div>
                            </DialogTitle>
                            <div className='h4-semibold ml-4'>Email Link</div>
                            <DialogContent className='p-0 mx-4 mt-1' >
                                <TextField
                                    disabled
                                    size='small'
                                    fullWidth
                                    className='p-0'
                                    variant="outlined"
                                    value={getUrlLink}
                                    InputProps={{ classes: { input: `h4-regular color-secure-file-dialog-title` } }}
                                />
                            </DialogContent>
                            <DialogActions className='pr-4'>
                                <ButtonComponent ButtonLabel={copyStatus.urlCopied ? buttonLabels.COPIED : buttonLabels.COPY} Variant={"secondary-btn"} ClassName='float-right mb-0 h5-regular ' OnClick={copyEmailLink} />
                            </DialogActions>
                            {PlanMetrics?.HasAccessToFaceVault &&
                                <>
                                    <div className='h4-semibold ml-4 mt-1'>Face Authentication Link</div>
                                    <DialogContent className='p-0 mx-4 mt-1 '>
                                        <TextField
                                            size='small'
                                            className='p-0'
                                            disabled
                                            fullWidth
                                            variant="outlined"
                                            value={faceUrlLink}
                                            InputProps={{ classes: { input: `h4-regular color-secure-file-dialog-title` } }}
                                        />
                                    </DialogContent>
                                    <DialogActions className='pr-4 mb-2'>
                                        <ButtonComponent ButtonLabel={copyStatus.faceUrlCopied ? buttonLabels.COPIED : buttonLabels.COPY} Variant={"secondary-btn"} ClassName='float-right mb-0 h5-regular ' OnClick={copyFaceLink} />
                                    </DialogActions>
                                </>
                            }
                        </Dialog>
                    }
                    {
                        location.pathname.replace("/*", "") === AppRoutes.SECURE_FILE ?
                            <div className="h-p-100">
                                <SecureFile
                                    onGridReady={onGridReady}
                                    OnSelectionChanged={(data) => onFilesSelectionChanged(data)}

                                />
                            </div>
                            :
                            <div className="h-p-100">
                                <SecureFileFaceAuthentication
                                    onGridReady={onGridReady}
                                    OnClose={() => { }}
                                    Show={false}
                                    OnSelectionChanged={(data) => onSelectionChanged(data)}
                                />
                            </div>
                    }
                    {
                        showSendInvite &&
                        <SendInviteComponent
                            Show={showSendInvite}
                            OnClose={closeSendInvite}
                        />
                    }
                    {
                        showUploadSecureFile &&
                        <UploadSecureFile
                            Show={showUploadSecureFile}
                            OnClose={closeUploadFileDialog}
                            SecureFiles={SecureFiles}
                        />
                    }
                    {
                        Boolean(anchorEl) &&
                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleCloseFilter}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            // BackdropProps={{
                            //     invisible: true,
                            //     onClick: (event) => event.stopPropagation(),
                            // }}
                            classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
                        >
                            <FilterComponent
                                Filters={filterOptions}
                                HandleApplyFilters={handleApplyFilters}
                                OnClose={handleCloseFilter}
                            />
                        </Popover>
                    }
                    {showContactDeleteConfirmDialog &&
                        <ConfirmDialog
                            ButtonName={buttonLabels.DELETE}
                            onClose={closeContactDeleteConfirmDialog}
                            Show={showContactDeleteConfirmDialog}
                            Text={appNote.DELETE_INVITE}
                            Loading={isLoading}
                        />}
                    {showFilesDeleteConfirmDialog &&
                        <ConfirmDialog
                            ButtonName={buttonLabels.DELETE}
                            onClose={closeSecureFilesDeleteConfirmDailog}
                            Show={showFilesDeleteConfirmDialog}
                            Text={appNote.SECURE_FILE}
                            Loading={isLoading}
                        />

                    }
                </div>
            }
        </>
    )
}
export default SecureFiles;